"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCALE_TYPES = exports.ScaleType = void 0;
var ScaleType;
(function (ScaleType) {
    ScaleType["_1_6"] = "1-6";
    ScaleType["_6_1"] = "6-1";
    ScaleType["_1_5"] = "1-5";
    ScaleType["_5_1"] = "5-1";
})(ScaleType = exports.ScaleType || (exports.ScaleType = {}));
// [ '1-6', '6-1', '1-5', '5-1' ]
exports.SCALE_TYPES = Object.keys(ScaleType).map(function (k) { return ScaleType[k]; });
